import { useRef, useState } from "react";
import { Popover } from "@headlessui/react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";
import { t } from "@/i18n-js/instance";
import { EventItemButton } from "./Events/EventItemButton";
import { EventPopoverContent } from "./Events/EventPopoverContent";
import { POPOVER_OPTIONS } from "./constants";

const HEADLESS_UI_POPOVER_ROOT = "headless-ui-popover-root";

export const EventPopover = ({
  isOneDayEvent,
  onChange,
  eventInfo,
  event,
  selectedEvent,
  setSelectedEvent,
}: any) => {
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const portalRoot = document.getElementById(HEADLESS_UI_POPOVER_ROOT);
  const [referenceElement, setReferenceElement] =
    useState<HTMLButtonElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { styles, attributes } = usePopper(
    referenceElement,
    popperElement,
    POPOVER_OPTIONS,
  );

  useClickAway(popoverRef, () => {
    const isModalOpen = document.getElementById("headlessui-portal-root");
    if (!isModalOpen) {
      setSelectedEvent({});
    }
  });

  return (
    <Popover className="relative w-full">
      <Popover.Button
        as={EventItemButton}
        eventInfo={eventInfo}
        isOneDayEvent={isOneDayEvent}
        event={event}
        ref={setReferenceElement}
        aria-label={t("all_events.event_details")}
      />
      {selectedEvent.id == event.id &&
        eventInfo.isStart && // This condition to show the popover only once in case of multi-day events
        createPortal(
          <Popover.Panel
            static
            className="z-10"
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
          >
            <div ref={popoverRef}>
              <EventPopoverContent
                title={eventInfo.event.title}
                onChange={onChange}
                event={event}
              />
            </div>
          </Popover.Panel>,
          portalRoot || document.body,
        )}
    </Popover>
  );
};
